import session from "@/api/session";

export default {
  getRetentionLeads(filters) {
    return session.get(`/leads/retention/`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },
  getRetentionLead(id){
    return session.get(`/leads/retention/${id}/`);
  },
  getAgents() {
    return session.get(`crm-users/?role=retentions`);
  },
  getAuditHistory(id,config) {
    return session.get(`/leads/retention/${id}/audit/?order=desc&page=${config.paginationPage}&limit=${config.paginationLimit}`);
  },
  createRetentionLead(data) {
    return session.post(`/leads/retention/`,JSON.stringify(data));
  },
  createRetentionLeadRecord(data){
    return session.post(`/leads/retention/records/`,JSON.stringify(data));
  },
  updateRetentionLeadRecord(data){
    return session.patch(`/leads/retention/records/${data.id}/`,JSON.stringify(data));
  },
  updateRetentionLead(data){
    return session.patch(`/leads/retention/${data.id}/`,JSON.stringify(data.data));
  },

  downloadExport(filters){
    return session.get(`/leads/retention/?export=dialler`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  getRetentionReports(start,end) {
    if(start!==''&&end!==''){
      return Promise.all([
        session.get(`/leads/retention/analytics/saved-vs-lost/?start_date=${start}&end_date=${end}`),
        session.get(`/leads/retention/analytics/cancellation-reasons/?start_date=${start}&end_date=${end}`),
        session.get(`/leads/retention/analytics/departments/?start_date=${start}&end_date=${end}`)
      ]);
    }else{
      return Promise.all([
        session.get(`/leads/retention/analytics/saved-vs-lost/`),
        session.get(`/leads/retention/analytics/cancellation-reasons/`),
        session.get(`/leads/retention/analytics/departments/`)
      ]);
    }
  },

  sendCustomerProformaInvoice(id) {
    return session.post(`/leads/retention/${id}/actions/send-proforma-invoice/`);
  },

  fetchProformaInvoiceData(id) {
    return session.get(`/leads/retention/${id}/proforma-invoice/`);
  },

  fetchAdhocInvoiceData(id) {
    return session.get(`/leads/retention/${id}/adhoc-invoice/`);
  },

  updateAdhocInvoiceData(id, payload) {
    return session.post(`/leads/retention/${id}/adhoc-invoice/`, payload);
  },

  downloadAdhocInvoice(invoiceId) {
    return session.get(`/adhoc-invoices/${invoiceId}/pdf/`, { responseType: "blob" });
  },

  downloadProformaInvoice(accountId) {
    return session.get(`/leads/retention/${accountId}/proforma/pdf/`, { responseType: "blob" });
  },

  fetchRetentionLeadNotes(id) {
    return session.get(`/leads/retention/${id}/notes/`);
  },

  createRetentionLeadNote(id, payload) {
    return session.post(`/leads/retention/${id}/notes/`, payload);
  },
};
